var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRequestWorkspace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6324_106549",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6324_106549)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.90689 16.7584C4.53846 16.7584 4.22306 16.6272 3.9607 16.3649C3.69833 16.1025 3.56714 15.7871 3.56714 15.4187V4.93155C3.56714 4.56312 3.69833 4.24772 3.9607 3.98536C4.22306 3.72299 4.53846 3.5918 4.90689 3.5918H15.394C15.7624 3.5918 16.0778 3.72299 16.3402 3.98536C16.6026 4.24772 16.7338 4.56312 16.7338 4.93155V15.4187C16.7338 15.7871 16.6026 16.1025 16.3402 16.3649C16.0778 16.6272 15.7624 16.7584 15.394 16.7584H4.90689ZM4.90689 15.6751H15.394C15.4688 15.6751 15.5302 15.6511 15.5783 15.603C15.6264 15.5549 15.6505 15.4935 15.6505 15.4187V6.17511H4.65045V15.4187C4.65045 15.4935 4.67449 15.5549 4.72258 15.603C4.77066 15.6511 4.8321 15.6751 4.90689 15.6751ZM6.6921 9.94592C6.53864 9.94592 6.41 9.89441 6.30618 9.79138C6.20236 9.68835 6.15045 9.56069 6.15045 9.40838C6.15045 9.25608 6.20236 9.12704 6.30618 9.02128C6.41 8.91551 6.53864 8.86263 6.6921 8.86263H13.6088C13.7623 8.86263 13.8909 8.91414 13.9947 9.01717C14.0985 9.1202 14.1505 9.24787 14.1505 9.40017C14.1505 9.55248 14.0985 9.68151 13.9947 9.78728C13.8909 9.89304 13.7623 9.94592 13.6088 9.94592H6.6921ZM6.6921 12.9668C6.53864 12.9668 6.41 12.9152 6.30618 12.8122C6.20236 12.7092 6.15045 12.5815 6.15045 12.4292C6.15045 12.2769 6.20236 12.1479 6.30618 12.0421C6.41 11.9363 6.53864 11.8835 6.6921 11.8835H10.6088C10.7623 11.8835 10.8909 11.935 10.9947 12.038C11.0985 12.141 11.1505 12.2687 11.1505 12.421C11.1505 12.5733 11.0985 12.7023 10.9947 12.8081C10.8909 12.9139 10.7623 12.9668 10.6088 12.9668H6.6921Z",
    fill: "#4E4E4E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestWorkspace);
export default __webpack_public_path__ + "static/media/request-workspace.e238b592c7256d00507359b3b437ac5e.svg";
export { ForwardRef as ReactComponent };